/* Putzkopf – Shop-Logik (ohne Abhängigkeiten, läuft auch direkt per Doppelklick) */
(() => {
  'use strict';
  const P = window.PRODUKTE || [];
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const eur = n => n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const vatLabel = price => `inkl. 19 % MwSt. (${eur(Math.round(price * 100 * 19 / 119) / 100)})`;
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* privat */ } }
  };
  const byId = Object.fromEntries(P.map(p => [p.id, p]));
  // Bilder aus dem Netz: ohne Verbindung eine saubere Zeichnung zeigen
  document.addEventListener('error', e => { const i = e.target; if (i.tagName !== 'IMG') return; const s = i.getAttribute('src') || '', alt = (window.BILD_ALT || {})[s]; if (alt) i.src = alt; else if (/^https?:/.test(s) && !i.dataset.fb) { i.dataset.fb = '1'; i.src = window.PUTZKOPF_ASSETS['bilder/scherkopf.svg']; } }, true);
  const BRAND = { oralb: 'Oral-B', sonicare: 'Philips Sonicare' };
  const ZIELE = {
    plaque: 'Plaque-Entfernung', zahnfleisch: 'Zahnfleischpflege', weiss: 'Weißere Zähne',
    zwischenraum: 'Zahnzwischenräume', rundum: 'Rundum-Pflege', kinder: 'Für Kinder'
  };
  const HANDS = {
    sonicare: [['son-2100', '2100 Series'], ['son-3100', '3100 Series'], ['son-4100', '4100 Series'], ['son-5300', '5300 Series'], ['son-6100', 'ProtectiveClean 6100'], ['son-7100', '7100 Series'], ['son-9000', 'DiamondClean 9000'], ['son-9900', 'Prestige 9900'], ['son-kids', 'Sonicare For Kids']],
    oralb: [['ob-io2', 'iO 2'], ['ob-io3', 'iO 3'], ['ob-io4', 'iO 4'], ['ob-io5', 'iO 5'], ['ob-io6', 'iO 6'], ['ob-io7', 'iO 7'], ['ob-io8', 'iO 8'], ['ob-io9', 'iO 9'], ['ob-io10', 'iO 10'], ['ob-alt', 'Pro, Vitality, Genius']]
  };

  /* ---------- EAN-13 als SVG-Barcode ---------- */
  const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'];
  const G = L.map(s => [...s].map(b => b === '1' ? '0' : '1').reverse().join(''));
  const R = L.map(s => [...s].map(b => b === '1' ? '0' : '1').join(''));
  const PAR = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];
  function eanValid(e) {
    if (!/^\d{13}$/.test(e)) return false;
    const d = [...e].map(Number);
    return (10 - d.slice(0, 12).reduce((a, n, i) => a + n * (i % 2 ? 3 : 1), 0) % 10) % 10 === d[12];
  }
  function eanSVG(e) {
    if (!eanValid(e)) return '';
    const d = [...e].map(Number), par = PAR[d[0]];
    let bits = '101';
    for (let i = 1; i <= 6; i++) bits += (par[i - 1] === 'L' ? L : G)[d[i]];
    bits += '01010';
    for (let i = 7; i <= 12; i++) bits += R[d[i]];
    bits += '101';
    const guard = new Set([0, 1, 2, 45, 46, 47, 48, 49, 92, 93, 94]);
    let rects = '';
    [...bits].forEach((b, i) => { if (b === '1') rects += `<rect x="${i + 9}" y="0" width="1" height="${guard.has(i) ? 56 : 50}"/>`; });
    const t = (x, s) => `<text x="${x}" y="64" font-size="9" font-family="ui-monospace,Menlo,monospace" text-anchor="middle">${s}</text>`;
    return `<svg viewBox="0 0 113 66" role="img" aria-label="Barcode ${e}"><g fill="#000">${rects}${t(4, d[0])}${t(32, e.slice(1, 7))}${t(78, e.slice(7))}</g></svg>`;
  }

  /* ---------- Varianten (nur noch bei „Weitere Produkte“) ---------- */
  const sel = {};
  const curVar = p => { const s = sel[p.id] || {}; return p.varianten.find(v => Object.entries(s).every(([k, x]) => v.opts[k] === x)) || p.varianten[0]; };
  const imgOf = (p, v) => v.bild || p.bilder[0];
  /* Galerie einer Variante: eigenes Bild + neutrale Bilder, keine Packungsbilder anderer Varianten */
  const galOf = (p, v) => [...new Set([imgOf(p, v), ...p.bilder.filter(x => !p.varianten.some(w => w !== v && w.bild === x))])];
  const perUnit = v => v.stueck ? v.preis / v.stueck : null;
  const colorKey = v => (v || '').toLowerCase().replace('ß', 'ss');
  function swatches(p, compact) {
    const v = curVar(p);
    return p.optionen.filter(o => o.werte.length > 1).map(o => `
      <div class="${compact ? '' : 'opt-group'}">${compact ? '' : `<span>${esc(o.name)}: ${esc(v.opts[o.name] || '')}</span>`}
      <div class="swatches">${o.werte.map(w => `<button class="sw" data-id="${p.id}" data-opt="${esc(o.name)}" data-val="${esc(w)}" aria-pressed="${v.opts[o.name] === w}">${esc(w)}</button>`).join('')}</div></div>`).join('');
  }
  const isBrand = p => p.art === 'kopf' || p.art === 'buerste';
  function varLine(p) {
    if (!isBrand(p)) return '';
    const farbe = p.varianten[0].opts.Farbe;
    return `<div class="var">${farbe ? `<span class="dotc ${colorKey(farbe)}"></span>` : ''}${esc(p.variante)}</div>`;
  }

  /* ---------- Grid ---------- */
  const f = { art: 'alle', marke: 'alle', q: '', sort: 'empf' };
  function priceLabel(p, v, showVat = true) {
    const pu = perUnit(v);
    const unit = p.art === 'kopf' ? 'Kopf' : (v.einheit === 'Stück' || !v.einheit ? 'Stück' : v.einheit.replace(/n$/, ''));
    return `<div class="price">${showVat ? `<small class="vat">${vatLabel(v.preis)}</small>` : ''}${eur(v.preis)}<small>${pu && v.stueck > 1 ? eur(pu) + ' / ' + unit : '&nbsp;'}</small></div>`;
  }
  /* Kleiner Roboter, der beim Drüberfahren oben über die Karte schaut und winkt */
  const BOT = `<div class="bot" aria-hidden="true"><svg viewBox="0 0 96 70">
    <g class="bot-body">
      <line x1="44" y1="6" x2="44" y2="15" stroke="#2f92e8" stroke-width="3" stroke-linecap="round"/>
      <circle class="bot-led" cx="44" cy="6" r="4" fill="#ff6b8a"/>
      <rect x="11" y="27" width="8" height="14" rx="4" fill="#2f92e8"/><rect x="69" y="27" width="8" height="14" rx="4" fill="#2f92e8"/>
      <rect x="16" y="14" width="56" height="44" rx="15" fill="#eef6ff" stroke="#2f92e8" stroke-width="3"/>
      <rect x="23" y="22" width="42" height="24" rx="10" fill="#16324f"/>
      <g class="bot-eyes" fill="#6fe3ff"><ellipse cx="35" cy="32" rx="4" ry="5"/><ellipse cx="53" cy="32" rx="4" ry="5"/></g>
      <path d="M37 39 Q44 44 51 39" stroke="#6fe3ff" stroke-width="2.6" fill="none" stroke-linecap="round"/>
      <circle cx="27" cy="51" r="3" fill="#ffb3c4"/><circle cx="61" cy="51" r="3" fill="#ffb3c4"/>
    </g>
    <g class="bot-grip"><rect x="10" y="58" width="22" height="12" rx="6" fill="#eef6ff" stroke="#2f92e8" stroke-width="2.6"/><path d="M16 61v6M21 61v6M26 61v6" stroke="#2f92e8" stroke-width="2" stroke-linecap="round"/></g>
    <g class="bot-wave"><path d="M74 66 L82 42" stroke="#2f92e8" stroke-width="7" stroke-linecap="round"/><path d="M74 66 L82 42" stroke="#eef6ff" stroke-width="3" stroke-linecap="round"/>
      <circle cx="83" cy="36" r="9" fill="#eef6ff" stroke="#2f92e8" stroke-width="2.6"/><path d="M79 30v-4M83 28v-5M87 30v-4" stroke="#2f92e8" stroke-width="2.4" stroke-linecap="round"/></g>
  </svg></div>`;
  function card(p) {
    const v = curVar(p);
    const tag = isBrand(p) ? `<span class="pill ${p.marke}">${BRAND[p.marke]}</span>` : `<span class="pill kat">${esc(p.kat)}</span>`;
    return `<article class="card" data-card="${p.id}">${BOT}
      <div class="media" data-open="${p.id}"><img loading="lazy" src="${esc(imgOf(p, v))}" alt="${esc(p.kurz + ' ' + p.variante)}">${(() => { const z = galOf(p, v)[1]; return z ? `<img class="alt" loading="lazy" src="${esc(z)}" alt="" aria-hidden="true">` : ''; })()}<div class="tag">${tag}</div></div>
      <div class="body">
        <h3>${esc(p.kurz)}</h3>
        ${varLine(p)}
        <div class="goal">${p.art === 'kopf' ? p.ziel.map(z => ZIELE[z]).join(' · ') : p.art === 'buerste' ? esc(p.kat) : esc(p.hersteller || '')}</div>
        ${swatches(p, true)}
        <div class="foot">${priceLabel(p, v)}
          <button class="add" data-add="${p.id}" ${v.available ? '' : 'disabled'} aria-label="${esc(p.kurz)} ${v.available ? 'in den Warenkorb' : 'derzeit nicht verfügbar'}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div>
      </div></article>`;
  }
  function render() {
    const q = f.q.trim().toLowerCase();
    $('#brandSeg').hidden = f.art === 'mehr';
    $$('#brandSeg + .sep, #brandSeg').forEach(el => el.hidden = f.art === 'mehr');
    let list = P.filter(p => (f.art === 'alle' || p.art === f.art) && (!isBrand(p) || f.marke === 'alle' || p.marke === f.marke) && (f.art !== 'alle' || f.marke === 'alle' || isBrand(p)) &&
      (!q || [p.titel, p.kurz, p.variante, p.kat || '', ...p.varianten.map(v => v.ean)].join(' ').toLowerCase().includes(q)));
    if (f.sort === 'empf') { const R = { kopf: 0, buerste: 1, mehr: 2 }; list.sort((a, b) => R[a.art] - R[b.art]); }
    const pr = p => curVar(p).preis;
    if (f.sort === 'auf') list.sort((a, b) => pr(a) - pr(b));
    if (f.sort === 'ab') list.sort((a, b) => pr(b) - pr(a));
    if (f.sort === 'kopf') list.sort((a, b) => (perUnit(curVar(a)) ?? pr(a)) - (perUnit(curVar(b)) ?? pr(b)));
    $('#grid').innerHTML = list.length ? list.map(card).join('') : `<div class="empty">Nichts gefunden für „${esc(f.q)}“. Versuch es mit einem anderen Modellnamen.</div>`;
    $('#count').textContent = `${list.length} ${list.length === 1 ? 'Produkt' : 'Produkte'}`;
  }
  const refreshCard = id => { const el = $(`[data-card="${id}"]`); if (el) el.outerHTML = card(byId[id]); };

  /* ---------- Produkt-Modal ---------- */
  let qty = 1;
  const baseTitle = document.title, metaDesc = document.querySelector('meta[name="description"]'), baseDesc = metaDesc ? metaDesc.content : '';
  function setMeta(p) {
    document.title = p ? `${p.kurz}${p.variante ? ' – ' + p.variante : ''} kaufen | Putzkopf` : baseTitle;
    if (metaDesc) metaDesc.content = p ? `${p.kurz}${p.variante ? ' (' + p.variante + ')' : ''}: ${p.text}`.slice(0, 158) : baseDesc;
  }
  function openPD(id) {
    const p = byId[id]; qty = 1; setMeta(p);
    const v = curVar(p);
    const imgs = galOf(p, v);
    const sibs = P.filter(x => x.gruppe === p.gruppe && x.art === 'kopf');
    const handNames = p.passt.map(h => (HANDS.sonicare.concat(HANDS.oralb).find(x => x[0] === h) || [])[1]).filter(Boolean);
    $('#pd').innerHTML = `<div class="pd">
      <div class="gal"><div class="big" id="big"><img src="${esc(imgs[0])}" alt="${esc(p.kurz)}"></div>
        ${imgs.length > 1 ? `<div class="thumbs">${imgs.map((s, i) => `<button data-g="${i}" aria-current="${i === 0}"><img src="${esc(s)}" alt="Bild ${i + 1}" loading="lazy"></button>`).join('')}</div>` : ''}
      </div>
      <div class="info">
        <div>${isBrand(p) ? `<span class="pill ${p.marke}">${BRAND[p.marke]}</span> <span class="pill">${p.art === 'kopf' ? 'Aufsteckbürsten' : 'Elektrische Zahnbürste'}</span>` : `<span class="pill kat">${esc(p.kat)}</span> <span class="pill">${esc(p.hersteller)}</span>`}</div>
        <h2 id="pdTitle">${esc(p.kurz)}</h2>
        <p class="sub">${esc(p.titel)}</p>
        <p class="desc">${esc(p.text)}</p>
        <ul class="feat">${p.features.map(x => `<li>${esc(x)}</li>`).join('')}</ul>
        ${sibs.length > 1 ? `<div class="opt-group"><span>Variante</span><div class="swatches">${sibs.map(s => `<button class="sw" data-open="${s.id}" aria-pressed="${s.id === p.id}">${esc(s.variante)}</button>`).join('')}</div></div>` : ''}
        ${swatches(p, false)}
        ${handNames.length ? `<div class="compat"><b>Passt auf:</b> ${p.marke === 'oralb' ? 'alle Oral-B iO Zahnbürsten (iO 2 bis iO 10)' : 'alle Sonicare Klick-Handstücke, z. B. ' + handNames.slice(2, 8).join(', ')}</div>` : ''}
        <p class="legal-price">${vatLabel(v.preis)}, <a href="#versand" data-legal="versand">kostenloser Versand</a><br><span class="ship"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>${v.available ? 'Auf Lager · Lieferzeit: ' + ((window.SHOP_INFO || {}).lieferzeit || '1–3 Werktage') : 'Derzeit nicht verfügbar'}</span></p>
        <div class="buy">${priceLabel(p, v, false)}
          <div style="display:flex;gap:10px;align-items:center"><div class="qty"><button data-q="-1" aria-label="weniger">−</button><output id="qty">1</output><button data-q="1" aria-label="mehr">+</button></div>
          <button class="btn btn-primary" data-add="${p.id}" data-modal="1" ${v.available ? '' : 'disabled'}>${v.available ? 'In den Warenkorb' : 'Derzeit nicht verfügbar'}</button></div></div>
      </div></div>`;
    $('#modal').classList.add('on'); $('#overlay').classList.add('on');
    document.body.style.overflow = 'hidden';
    $('#modalX').focus();
  }
  function closeAll() {
    setMeta(null);
    $('#modal').classList.remove('on'); $('#drawer').classList.remove('on'); $('#overlay').classList.remove('on');
    document.body.style.overflow = '';
  }

  /* ---------- Warenkorb ---------- */
  let cart = [], cartTotal = 0;
  const byVariantId = new Map(P.flatMap(p => p.varianten.filter(v => v.shopifyId).map(v => [v.shopifyId, { p, v }])));
  const shopCart = new window.PutzkopfCart({
    root: (window.PUTZKOPF_COMMERCE || {}).root || '/',
    onChange(data) {
      cartTotal = data.total_price / 100;
      cart = data.items.map(item => {
        const known = byVariantId.get(item.variant_id);
        return { k: item.key, id: known?.p.id, ean: known?.v.ean || '', n: item.quantity,
          title: item.product_title, variantTitle: item.variant_title || '',
          image: item.image || (known ? imgOf(known.p, known.v) : ''),
          price: item.final_price / 100, lineTotal: item.final_line_price / 100 };
      });
      drawCart();
    },
    onBusy(busy) {
      $('#checkoutBtn').disabled = busy || !cart.length;
      $('#drawer').setAttribute('aria-busy', String(busy));
      $$('#drawer [data-cq], #drawer [data-rm]').forEach(button => { button.disabled = busy; });
    }
  });
  async function addToCart(id, n = 1, from) {
    const p = byId[id], v = curVar(p);
    if (!v.available || !v.shopifyId) return toast('Dieser Artikel ist derzeit nicht verfügbar.');
    try {
      await shopCart.add(v.shopifyId, n);
      if (from) flyTo(from, imgOf(p, v));
      const b = $('#cartCount'); b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
      toast(`${p.kurz} ${n > 1 ? '(' + n + '×) ' : ''}im Warenkorb`, true);
    } catch (error) { toast(error.message); }
  }
  function drawCart() {
    const cnt = cart.reduce((sum, item) => sum + item.n, 0);
    $('#items').innerHTML = cart.length ? cart.map(it => {
      const p = byId[it.id];
      const label = p ? p.kurz : it.title;
      const options = p && isBrand(p) ? p.variante : it.variantTitle;
      return `<div class="it">${it.image ? `<img src="${esc(it.image)}" alt="" width="80" height="80">` : ''}
        <div><strong>${esc(label)}</strong><span>${esc(options === 'Default Title' ? '' : options)}</span>
        <div class="qty" style="margin-top:6px;transform:scale(.85);transform-origin:left"><button data-cq="${esc(it.k)}" data-d="-1">−</button><output>${it.n}</output><button data-cq="${esc(it.k)}" data-d="1">+</button></div></div>
        <div class="r"><b>${eur(it.lineTotal)}</b><br><button class="rm" data-rm="${esc(it.k)}">Entfernen</button></div></div>`;
    }).join('') : '<p style="color:var(--muted);padding:30px 0;text-align:center">Dein Warenkorb ist noch leer.<br>Zeit für einen frischen Kopf!</p>';
    $('#total').textContent = eur(cartTotal);
    const badge = $('#cartCount'); badge.textContent = cnt; badge.classList.toggle('on', cnt > 0);
    $('#checkoutBtn').disabled = shopCart.pending > 0 || !cart.length;
  }
  function flyTo(fromEl, src) {
    const a = fromEl.getBoundingClientRect(), b = $('#cartBtn').getBoundingClientRect();
    const d = document.createElement('div'); d.className = 'fly';
    d.style.left = a.left + a.width / 2 - 30 + 'px'; d.style.top = a.top + a.height / 2 - 30 + 'px';
    d.style.backgroundImage = `url("${src}")`;
    document.body.appendChild(d);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      d.style.transform = `translate(${b.left - a.left - a.width / 2 + 52}px,${b.top - a.top - a.height / 2 + 52}px) scale(.25)`;
      d.style.opacity = '.4';
    }));
    setTimeout(() => d.remove(), 800);
  }
  function cartCSV() {
    const rows = [['Produkt', 'Variante', 'EAN', 'Menge', 'Einzelpreis', 'Summe']];
    cart.forEach(it => {
      const p = byId[it.id];
      rows.push([p ? p.titel : it.title, it.variantTitle, it.ean, it.n, it.price.toFixed(2).replace('.', ','), it.lineTotal.toFixed(2).replace('.', ',')]);
    });
    return rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(';')).join('\r\n');
  }
  function download(name, text, type) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob(['﻿' + text], { type }));
    a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  }
  let tT;
  function toast(t, cartLink) {
    const el = $('#toast'); el.textContent = t;
    if (cartLink) { const b = document.createElement('button'); b.type = 'button'; b.className = 'toast-go'; b.textContent = 'Zum Warenkorb →'; b.addEventListener('click', openCart); el.append(' ', b); }
    el.classList.add('on'); clearTimeout(tT); tT = setTimeout(() => el.classList.remove('on'), cartLink ? 4200 : 2200);
  }
  function openCart() { shopCart.load().catch(error => toast(error.message)); $('#modal').classList.remove('on'); $('#drawer').classList.add('on'); $('#overlay').classList.add('on'); $('#toast').classList.remove('on'); }

  /* ---------- Kopf-Finder ---------- */
  const fs = { marke: null, hand: null, ziel: null };
  const optBtn = (k, v, label, sub) => `<button class="opt" data-f="${k}" data-v="${v}" aria-pressed="${fs[k] === v}">${label}${sub ? `<small>${sub}</small>` : ''}</button>`;
  const firstOfGroup = list => list.filter((p, i, a) => a.findIndex(x => x.gruppe === p.gruppe) === i);
  function drawFinder() {
    $('#o1').innerHTML = optBtn('marke', 'sonicare', 'Philips Sonicare', 'Schallzahnbürste') + optBtn('marke', 'oralb', 'Oral-B', 'iO / rotierend');
    $('#s2').classList.toggle('locked', !fs.marke); $('#s3').classList.toggle('locked', !fs.hand);
    $('#o2').innerHTML = fs.marke ? HANDS[fs.marke].map(([id, n]) => optBtn('hand', id, n)).join('') : '<span style="opacity:.6">Erst Marke wählen …</span>';
    const zs = fs.marke === 'oralb' ? ['plaque', 'rundum'] : ['plaque', 'zahnfleisch', 'weiss', 'zwischenraum', 'rundum', 'kinder'];
    $('#o3').innerHTML = fs.hand ? zs.map(z => optBtn('ziel', z, ZIELE[z])).join('') : '<span style="opacity:.6">Erst Handstück wählen …</span>';
    const r = $('#fres');
    if (!fs.hand || !fs.ziel) { r.hidden = true; return; }
    r.hidden = false;
    if (fs.hand === 'ob-alt') {
      r.innerHTML = `<h3 style="font-size:1.4rem">Achtung: kein iO-Handstück</h3><p style="opacity:.8;max-width:60ch">Unsere Oral-B iO Köpfe passen nur auf iO-Zahnbürsten. Für Pro, Vitality und Genius brauchst du klassische Oral-B Aufsteckbürsten – die führen wir aktuell nicht.</p>`;
      return;
    }
    let heads = firstOfGroup(P.filter(p => p.art === 'kopf' && p.passt.includes(fs.hand)));
    heads.sort((a, b) => (b.ziel[0] === fs.ziel) - (a.ziel[0] === fs.ziel) || b.ziel.includes(fs.ziel) - a.ziel.includes(fs.ziel));
    const best = heads.filter(h => h.ziel.includes(fs.ziel)), rest = heads.filter(h => !h.ziel.includes(fs.ziel)).slice(0, 3);
    const hn = HANDS[fs.marke].find(x => x[0] === fs.hand)[1];
    r.innerHTML = `<h3 style="font-size:1.4rem">${best.length ? 'Unsere Empfehlung' : 'Passende Köpfe'} für ${esc(hn)}</h3>
      <div class="reco">${best.map((h, i) => recoCard(h, i === 0)).join('')}${rest.map(h => recoCard(h)).join('')}</div>`;
  }
  function recoCard(p, best) {
    const sib = P.filter(x => x.gruppe === p.gruppe);
    return `<button class="rc" data-open="${p.id}"><img src="${esc(imgOf(p, p.varianten[0]))}" alt=""><div>${best ? '<span class="best">★ Beste Wahl</span>' : ''}<strong>${esc(p.kurz)}</strong><span>${sib.length > 1 ? sib.length + ' Varianten · ab ' : ''}${eur(Math.min(...sib.map(x => x.varianten[0].preis)))}</span></div></button>`;
  }

  /* ---------- Wechsel-Wecker ---------- */
  function addMonths(d, m) { const x = new Date(d); x.setMonth(x.getMonth() + m); return x; }
  const fmt = d => d.toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  function wecker() {
    const lastV = $('#last').value, m = +$('#intv').value, ppl = Math.max(1, +$('#ppl').value || 1);
    const p = byId[$('#headSel').value] || P.find(x => x.art === 'kopf'), v = p.varianten[0];
    const last = lastV ? new Date(lastV + 'T09:00') : new Date();
    const next = addMonths(last, m), now = new Date();
    const left = Math.ceil((next - now) / 864e5), frac = Math.min(1, Math.max(0, (now - last) / (next - last)));
    $('#gArc').style.strokeDashoffset = 314.16 * (1 - frac);
    $('#gArc').style.stroke = frac > .9 ? '#d9483b' : frac > .66 ? 'var(--honey)' : 'var(--accent)';
    $('#gVal').textContent = left > 0 ? left : 'Jetzt!';
    $('#gLbl').textContent = left > 0 ? (left === 1 ? 'Tag bis zum nächsten Wechsel' : 'Tage bis zum nächsten Wechsel') : 'Dein Kopf ist überfällig – Zeit zu wechseln';
    $('#gDate').textContent = 'Nächster Wechsel: ' + fmt(next);
    $$('#bristles i').forEach((b, i) => {
      b.style.height = (100 - frac * 35 - Math.abs(Math.cos(i)) * frac * 20) + '%';
      b.style.transform = `rotate(${Math.sin(i * 1.7) * frac * 22}deg)`;
      b.style.opacity = 1 - frac * .35;
    });
    const heads = Math.ceil(12 / m) * ppl, st = v.stueck || 4, packs = Math.ceil(heads / st);
    $('#kHeads').textContent = heads; $('#kPacks').textContent = packs;
    $('#kDay').textContent = eur(v.preis / st * (12 / m) / 365);
    store.set('kopfsache-wecker-v2', { last: lastV, m, ppl, head: p.id });
    return { next, p, packs, m };
  }
  function ics() {
    const { next, p, m } = wecker();
    const d = x => x.toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
    const day = next.toISOString().slice(0, 10).replace(/-/g, '');
    const txt = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Putzkopf//Wechsel-Wecker//DE', 'BEGIN:VEVENT',
      'UID:' + Date.now() + '@putzkopf', 'DTSTAMP:' + d(new Date()), 'DTSTART;VALUE=DATE:' + day,
      'RRULE:FREQ=MONTHLY;INTERVAL=' + m, 'SUMMARY:Zeit für einen neuen Bürstenkopf',
      'DESCRIPTION:' + p.kurz + ' – alle ' + m + ' Monate wechseln.',
      'BEGIN:VALARM', 'TRIGGER:-PT0M', 'ACTION:DISPLAY', 'DESCRIPTION:Bürstenkopf wechseln', 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    download('buerstenkopf-wechsel.ics', txt, 'text/calendar');
    toast('Kalender-Erinnerung erstellt');
  }

  /* ---------- Kleinkram ---------- */
  function marquee() {
    const t = ['Original Philips Sonicare', 'Original Oral-B iO', 'Alle 3 Monate wechseln', 'Original-Ware', 'Kopf-Finder in 3 Klicks', 'Kalender-Erinnerung', 'Für Groß & Klein'];
    const html = t.map(x => `<span>${x}</span>`).join('');
    $('#marquee').innerHTML = html + html;
  }
  function theme() { try { localStorage.removeItem('kopfsache-theme'); } catch (e) {} delete document.documentElement.dataset.theme; }
  const setPressed = (sel, fn) => $$(sel).forEach(b => b.setAttribute('aria-pressed', fn(b)));

  /* ---------- Events ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('button,a,[data-open]');
    if (!t) return;
    if (t.dataset.art) { f.art = t.dataset.art; setPressed('[data-art]', b => b === t); render(); }
    else if (t.dataset.marke) { f.marke = t.dataset.marke; setPressed('[data-marke]', b => b === t); render(); }
    else if (t.dataset.jump) { f.art = t.dataset.jump; setPressed('[data-art]', b => b.dataset.art === f.art); render(); $('#nav').classList.remove('open'); }
    else if (t.dataset.opt) {
      const p = byId[t.dataset.id];
      const s = { ...curVar(p).opts, [t.dataset.opt]: t.dataset.val };
      sel[p.id] = p.varianten.some(v => Object.entries(s).every(([k, x]) => v.opts[k] === x)) ? s : { ...p.varianten.find(v => v.opts[t.dataset.opt] === t.dataset.val).opts };
      if (t.closest('#modal')) openPD(p.id);
      refreshCard(p.id);
    }
    else if (t.dataset.add) { e.preventDefault(); addToCart(t.dataset.add, t.dataset.modal ? qty : 1, t.closest('.card,.buy')?.querySelector('img') || t); }
    else if (t.dataset.open) { e.preventDefault(); openPD(t.dataset.open); }
    else if (t.dataset.g) { $('#big img').src = t.querySelector('img').src; $$('.thumbs button').forEach(b => b.setAttribute('aria-current', b === t)); }
    else if (t.dataset.q) { qty = Math.max(1, qty + +t.dataset.q); $('#qty').textContent = qty; }
    else if (t.dataset.copy) {
      const txt = t.dataset.copy;
      Promise.resolve().then(() => navigator.clipboard.writeText(txt)).then(() => toast('EAN kopiert'), () => {
        const r = document.createRange(); r.selectNodeContents(t.previousElementSibling); const s = getSelection(); s.removeAllRanges(); s.addRange(r); toast('EAN markiert – mit ⌘C kopieren');
      });
    }
    else if (t.dataset.f) { fs[t.dataset.f] = t.dataset.v; if (t.dataset.f === 'marke') { fs.hand = null; fs.ziel = null; } if (t.dataset.f === 'hand') fs.ziel = null; drawFinder(); }
    else if (t.dataset.cq) { const it = cart.find(x => x.k === t.dataset.cq); if (it) shopCart.change(it.k, Math.max(0, it.n + +t.dataset.d)).catch(error => toast(error.message)); }
    else if (t.dataset.rm) { shopCart.change(t.dataset.rm, 0).catch(error => toast(error.message)); }
  });
  document.addEventListener('click', e => { const big = e.target.closest('#big'); if (big) { const lb = $('#lightbox'); lb.querySelector('img').src = big.querySelector('img').src; lb.classList.add('on'); } });
  $('#lightbox').addEventListener('click', () => $('#lightbox').classList.remove('on'));
  $('#overlay').addEventListener('click', closeAll);
  $('#modalX').addEventListener('click', closeAll);
  $('#drawerX').addEventListener('click', closeAll);
  $('#cartBtn').addEventListener('click', openCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeAll(); $('#lightbox').classList.remove('on'); } });
  $('#menuBtn').addEventListener('click', () => { const o = $('#nav').classList.toggle('open'); $('#menuBtn').setAttribute('aria-expanded', o); });
  $$('#nav a').forEach(a => a.addEventListener('click', () => $('#nav').classList.remove('open')));
  $('#q').addEventListener('input', e => { f.q = e.target.value; render(); });
  $('#sort').addEventListener('change', e => { f.sort = e.target.value; render(); });
  addEventListener('scroll', () => $('#top').classList.toggle('scrolled', scrollY > 10), { passive: true });
  $('#csvBtn').addEventListener('click', () => cart.length ? download('putzkopf-warenkorb.csv', cartCSV(), 'text/csv') : toast('Warenkorb ist leer'));
  $('#checkoutForm').addEventListener('submit', async event => {
    event.preventDefault();
    try {
      const latest = await shopCart.load();
      if (!latest.item_count) return toast('Warenkorb ist leer');
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'checkout'; input.value = 'checkout';
      event.target.appendChild(input);
      event.target.submit();
    } catch (error) { toast(error.message); }
  });
  ['last', 'intv', 'ppl', 'headSel'].forEach(id => $('#' + id).addEventListener('input', wecker));
  $('#icsBtn').addEventListener('click', ics);
  $('#weckerAdd').addEventListener('click', e => { const { p, packs } = wecker(); if (p) addToCart(p.id, packs, e.currentTarget); });

  /* Video erst laden, wenn es ins Bild kommt (schnellerer Seitenstart) */
  const film = $('#film video');
  if (film) {
    const go = () => { film.querySelectorAll('source[data-src]').forEach(x => { x.src = x.dataset.src; x.removeAttribute('data-src'); }); film.load(); film.play().catch(() => {}); };
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver(es => { if (es.some(x => x.isIntersecting)) { io.disconnect(); go(); } }, { rootMargin: '300px' }); io.observe(film); } else go();
  }
  /* ---------- Start ---------- */
  theme();
  /* ---------- Aufklapp-Menü im Header ---------- */
  const MEGA = {
    kopf: ['Bürstenköpfe', 'Original-Aufsteckbürsten für Philips Sonicare und Oral-B iO – jede Packung einzeln.', 'Alle Bürstenköpfe'],
    buerste: ['Zahnbürsten', 'Die Oral-B iO Familie: vom Einstieg iO 5 bis zum Spitzenmodell iO 10.', 'Alle Zahnbürsten'],
    mehr: ['Weitere Produkte', 'Pflege für Kaffeemaschine, Rasierer und Bad.', 'Alle weiteren Produkte']
  };
  $$('.mega').forEach(m => {
    const art = m.dataset.mega, [h, txt, all] = MEGA[art];
    const items = art === 'kopf' ? firstOfGroup(P.filter(p => p.art === 'kopf')) : P.filter(p => p.art === art);
    m.innerHTML = `<div class="mega-in"><div class="mega-head"><h4>${h}</h4><p>${txt}</p><a href="#shop" data-jump="${art}">${all} →</a></div>
      <div class="mega-grid">${items.slice(0, 8).map(p => { const v = p.varianten[0]; return `<a class="mega-tile" href="#shop" data-open="${p.id}"><img src="${esc(imgOf(p, v))}" alt="" loading="lazy"><b>${esc(p.kurz)}</b><small>ab ${eur(Math.min(...P.filter(x => x.gruppe === p.gruppe).map(x => x.varianten[0].preis)))}</small></a>`; }).join('')}</div></div>`;
  });
  $$('.mega').forEach(m => m.addEventListener('click', e => { if (e.target.closest('a')) { document.activeElement?.blur(); m.closest('.nav-item').classList.add('shut'); setTimeout(() => m.closest('.nav-item').classList.remove('shut'), 400); } }));
  $('#headSel').innerHTML = P.filter(p => p.art === 'kopf').map(p => `<option value="${p.id}">${esc(p.kurz)} – ${esc(p.variante)}</option>`).join('');
  const w = store.get('kopfsache-wecker-v2', null);
  const def = new Date(); def.setDate(def.getDate() - 50);
  $('#last').value = w?.last || def.toISOString().slice(0, 10);
  if (w) { $('#intv').value = w.m; $('#ppl').value = w.ppl; if (byId[w.head]) $('#headSel').value = w.head; }
  $('#bristles').innerHTML = '<i></i>'.repeat(18);
  render(); drawCart(); drawFinder(); marquee(); wecker();
  shopCart.load().catch(error => toast(error.message));
})();
